/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformerMedia } from './PerformerMedia';
import {
    PerformerMediaFromJSON,
    PerformerMediaFromJSONTyped,
    PerformerMediaToJSON,
    PerformerMediaToJSONTyped,
} from './PerformerMedia';
import type { PrimaryCategoryEnum } from './PrimaryCategoryEnum';
import {
    PrimaryCategoryEnumFromJSON,
    PrimaryCategoryEnumFromJSONTyped,
    PrimaryCategoryEnumToJSON,
    PrimaryCategoryEnumToJSONTyped,
} from './PrimaryCategoryEnum';

/**
 * Serializer for Performer model with comprehensive details.
 * @export
 * @interface PatchedPerformer
 */
export interface PatchedPerformer {
    /**
     * 
     * @type {string}
     * @memberof PatchedPerformer
     */
    readonly id?: string;
    /**
     * Artist or band name (must be unique)
     * @type {string}
     * @memberof PatchedPerformer
     */
    performerName?: string;
    /**
     * Artist/band biography and description
     * @type {string}
     * @memberof PatchedPerformer
     */
    bio?: string;
    /**
     * 
     * @type {PrimaryCategoryEnum}
     * @memberof PatchedPerformer
     */
    primaryCategory?: PrimaryCategoryEnum;
    /**
     * Searchable tags (e.g., "touring", "local", "established")
     * @type {Array<string>}
     * @memberof PatchedPerformer
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatchedPerformer
     */
    website?: string;
    /**
     * Social media links: facebook, instagram, twitter, spotify, etc.
     * @type {any}
     * @memberof PatchedPerformer
     */
    socialMedia?: any | null;
    /**
     * Performer's hometown (city, state/region, country)
     * @type {any}
     * @memberof PatchedPerformer
     */
    hometown?: any | null;
    /**
     * Stage plot, equipment, and technical requirements
     * @type {string}
     * @memberof PatchedPerformer
     */
    technicalRider?: string;
    /**
     * Dressing room, catering, and hospitality requirements
     * @type {string}
     * @memberof PatchedPerformer
     */
    hospitalityRider?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPerformer
     */
    readonly hasBio?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPerformer
     */
    readonly hasTechnicalRider?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPerformer
     */
    readonly hasHospitalityRider?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPerformer
     */
    readonly hasMedia?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatchedPerformer
     */
    readonly profileCompletion?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedPerformer
     */
    readonly bookingCount?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedPerformer
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PatchedPerformer
     */
    createdBy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedPerformer
     */
    readonly createdByName?: string;
    /**
     * 
     * @type {Array<PerformerMedia>}
     * @memberof PatchedPerformer
     */
    readonly media?: Array<PerformerMedia>;
    /**
     * 
     * @type {Date}
     * @memberof PatchedPerformer
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedPerformer
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the PatchedPerformer interface.
 */
export function instanceOfPatchedPerformer(value: object): value is PatchedPerformer {
    return true;
}

export function PatchedPerformerFromJSON(json: any): PatchedPerformer {
    return PatchedPerformerFromJSONTyped(json, false);
}

export function PatchedPerformerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedPerformer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'performerName': json['performer_name'] == null ? undefined : json['performer_name'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'primaryCategory': json['primary_category'] == null ? undefined : PrimaryCategoryEnumFromJSON(json['primary_category']),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'website': json['website'] == null ? undefined : json['website'],
        'socialMedia': json['social_media'] == null ? undefined : json['social_media'],
        'hometown': json['hometown'] == null ? undefined : json['hometown'],
        'technicalRider': json['technical_rider'] == null ? undefined : json['technical_rider'],
        'hospitalityRider': json['hospitality_rider'] == null ? undefined : json['hospitality_rider'],
        'hasBio': json['has_bio'] == null ? undefined : json['has_bio'],
        'hasTechnicalRider': json['has_technical_rider'] == null ? undefined : json['has_technical_rider'],
        'hasHospitalityRider': json['has_hospitality_rider'] == null ? undefined : json['has_hospitality_rider'],
        'hasMedia': json['has_media'] == null ? undefined : json['has_media'],
        'profileCompletion': json['profile_completion'] == null ? undefined : json['profile_completion'],
        'bookingCount': json['booking_count'] == null ? undefined : json['booking_count'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdBy': json['created_by'] == null ? undefined : json['created_by'],
        'createdByName': json['created_by_name'] == null ? undefined : json['created_by_name'],
        'media': json['media'] == null ? undefined : ((json['media'] as Array<any>).map(PerformerMediaFromJSON)),
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedPerformerToJSON(json: any): PatchedPerformer {
      return PatchedPerformerToJSONTyped(json, false);
  }

  export function PatchedPerformerToJSONTyped(value?: Omit<PatchedPerformer, 'id'|'has_bio'|'has_technical_rider'|'has_hospitality_rider'|'has_media'|'profile_completion'|'booking_count'|'created_by_name'|'media'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'performer_name': value['performerName'],
        'bio': value['bio'],
        'primary_category': PrimaryCategoryEnumToJSON(value['primaryCategory']),
        'tags': value['tags'],
        'website': value['website'],
        'social_media': value['socialMedia'],
        'hometown': value['hometown'],
        'technical_rider': value['technicalRider'],
        'hospitality_rider': value['hospitalityRider'],
        'is_active': value['isActive'],
        'created_by': value['createdBy'],
    };
}

